import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.styl'

const Checked = ({ checked }) => {
  let content = null

  if (checked) {
    content = <span className="ico ico--checked" />
  }

  return (
    <span className={styles.modChecked}>
      {content}
    </span>
  )
}

Checked.propTypes = {
  checked: PropTypes.any
}

export default Checked
